var map = {
	"./chargingpoint-alert.png": 6292,
	"./chargingpoint-definitive.png": 6403,
	"./chargingpoint-in-progress.png": 8729,
	"./chargingpoint-realized.png": 3158,
	"./chargingpoint-rejected.png": 6874,
	"./chargingpoint-suggestion.png": 2363,
	"./disabled.png": 2246,
	"./map-pin-solid-red.png": 7948,
	"./old/chargingpoint-alert.png": 3302,
	"./old/chargingpoint-definitive.png": 2217,
	"./old/chargingpoint-fastcharger-planned.png": 8709,
	"./old/chargingpoint-fastcharger-realized.png": 1405,
	"./old/chargingpoint-in-progress.png": 2851,
	"./old/chargingpoint-realized-private.png": 3270,
	"./old/chargingpoint-realized.png": 7104,
	"./old/chargingpoint-suggestion.png": 4578,
	"./parking-permit-areas.png": 9655,
	"./request-accepted.png": 7581,
	"./request-active.png": 2200,
	"./request-connected.png": 3645,
	"./request-open.png": 8770,
	"./request-selected.png": 8617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3261;